import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames/bind';

import TrashIcon from '../../icons/TrashIcon';

import styles from './Trash.module.scss';

const cx = classNames.bind(styles);

const Trash = ({ onClick, className }) => {
  const handleClick = e => {
    e && e.stopPropagation();
    e && e.preventDefault();
    onClick();
  };

  return (
    <div role="button" tabIndex={0} className={className} onClick={handleClick}>
      <TrashIcon className={cx(styles.trash)} />
    </div>
  );
};

Trash.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string
};

Trash.defaultProps = {
  onClick: () => {},
  className: ''
};

export default Trash;
